import cx from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';
import styles from './OrganizationSubRow.module.scss';

interface IProps extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  title?: string;
  className?: string;
}

const OrganizationSubRow = ({
  className,
  title,
  children,
  ...props
}: IProps) => {
  return (
    <div className={cx(styles.mps, className)} {...props}>
      {title && <p className={styles.mpsTitle}>{title}</p>}
      {children}
    </div>
  );
};

export default OrganizationSubRow;
